import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7889549c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "navbar" }
const _hoisted_2 = { class: "navbar-nav site-nav" }
const _hoisted_3 = {
  key: 0,
  class: "nav-item hide-md"
}
const _hoisted_4 = {
  key: 1,
  class: "nav-item"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "nav-link",
    "data-bs-toggle": "collapse",
    "data-bs-target": "#exploreItems"
  }, " Explore ")
], -1))
const _hoisted_6 = {
  id: "exploreItems",
  class: "collapse"
}
const _hoisted_7 = { class: "navbar-nav" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "nav-item disabled" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "nav-link" }, " Places ")
], -1))
const _hoisted_9 = {
  key: 0,
  class: "nav-item dropdown"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "nav-link dropdown-toggle",
  "data-bs-toggle": "dropdown"
}, "Explore", -1))
const _hoisted_11 = { class: "dropdown-menu" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "dropdown-item disabled" }, " Places ", -1))
const _hoisted_13 = {
  key: 4,
  class: "nav-item"
}
const _hoisted_14 = { class: "nav-item" }

import { computed } from 'vue'
import { useRouter } from 'vue-router'
import { useUserStore } from '@/gp/UserStore'
import { useDataGroupStore } from "@/gp/DataGroupStore"
import { useViewPersonStore } from "@/rd/ViewPersonStore"
import { useExploreStore } from '@/explore/ExploreStore'
import { LoadMode } from '@/util/AsyncData'
import SiteSearch from './SiteSearch.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SiteNav',
  props: {
    asDrawer: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;



const userStore = useUserStore()
const dataGroupStore = useDataGroupStore()
const exploreStore = useExploreStore()

const userRef = computed(() => userStore.getAsyncSelf(LoadMode.EnsureLoaded)?.data)
const selfProfileRef = computed(() => dataGroupStore.getAsyncGroup(userRef.value?.profileDataGroupId, LoadMode.EnsureLoaded)?.data)

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      (userRef.value)
        ? (_openBlock(), _createElementBlock("li", _hoisted_3, [
            _createVNode(SiteSearch)
          ]))
        : _createCommentVNode("", true),
      (userRef.value)
        ? (_openBlock(), _createElementBlock("li", _hoisted_4, [
            _createVNode(_component_router_link, {
              class: "nav-link home",
              to: "/home"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Home ")
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (props.asDrawer)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _hoisted_5,
            _createElementVNode("li", _hoisted_6, [
              _createElementVNode("ul", _hoisted_7, [
                _createElementVNode("li", {
                  class: _normalizeClass(["nav-item", { disabled: !_unref(exploreStore).enableExploreRef }])
                }, [
                  _createVNode(_component_router_link, {
                    class: _normalizeClass(["nav-link", { disabled: !_unref(exploreStore).enableExploreRef }]),
                    to: selfProfileRef.value?.startPersonPageUrl ?? '#'
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Family ")
                    ]),
                    _: 1
                  }, 8, ["to", "class"])
                ], 2),
                _createElementVNode("li", {
                  class: _normalizeClass(["nav-item", { disabled: !_unref(exploreStore).enableExploreRef }])
                }, [
                  _createVNode(_component_router_link, {
                    class: _normalizeClass(["nav-link", { disabled: !_unref(exploreStore).enableExploreRef }]),
                    to: "/names"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Names ")
                    ]),
                    _: 1
                  }, 8, ["class"])
                ], 2),
                _hoisted_8
              ])
            ])
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
            (selfProfileRef.value?.startPersonPageUrl)
              ? (_openBlock(), _createElementBlock("li", _hoisted_9, [
                  _hoisted_10,
                  _createElementVNode("ul", _hoisted_11, [
                    _createElementVNode("li", {
                      class: _normalizeClass(["dropdown-item", { disabled: !_unref(exploreStore).enableExploreRef }])
                    }, [
                      _createVNode(_component_router_link, {
                        class: "link-dark",
                        to: selfProfileRef.value?.startPersonPageUrl ?? '#'
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Family ")
                        ]),
                        _: 1
                      }, 8, ["to"])
                    ], 2),
                    _createElementVNode("li", {
                      class: _normalizeClass(["dropdown-item", { disabled: !_unref(exploreStore).enableExploreRef }])
                    }, [
                      _createVNode(_component_router_link, {
                        class: "link-dark",
                        to: "/names"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Names ")
                        ]),
                        _: 1
                      })
                    ], 2),
                    _hoisted_12
                  ])
                ]))
              : _createCommentVNode("", true)
          ], 64)),
      (!userRef.value)
        ? (_openBlock(), _createElementBlock("li", _hoisted_13, [
            _createVNode(_component_router_link, {
              class: "nav-link",
              to: "/plans"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Plans ")
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("li", _hoisted_14, [
        _createVNode(_component_router_link, {
          class: "nav-link",
          to: "/support"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Support ")
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})